// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const BusinessStructureSelector: MarkdocTagRegistration = {
  tag: 'business-structure-selector',
  component: 'BusinessStructureSelector',
  attributes: {
    countries: {
      type: Array,
      default: [],
      description:
        'A map of ISO country code <> formatted country name. This should be $countries.business_structure_countries.',
    },
  },
};
